import { render, staticRenderFns } from "./ranking.component.vue?vue&type=template&id=00cd3c8e&scoped=true"
import script from "./ranking.component.vue?vue&type=script&lang=js"
export * from "./ranking.component.vue?vue&type=script&lang=js"
import style0 from "./ranking.component.vue?vue&type=style&index=0&id=00cd3c8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00cd3c8e",
  null
  
)

export default component.exports